
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import ModalWrapper from 'components/ModalWrapper'
import { useTranslation } from "react-i18next";
import TextArea from "components/forms/TextArea";
import ToggleSwitch from "components/actions/ToggleSwitch";
import SectionWrapper from "components/wrappers/SectionWrapper";
import { BiEditAlt } from 'react-icons/bi'
import Language from "components/Language";
import PropTypes from 'prop-types';

const EditAnnouncement = (props) => {

    const { t } = useTranslation();

    const { register, handleSubmit, formState: { errors, isValid } } = useForm({ mode: 'onChange', defaultValues: props.data });

    const [isOpen, setIsOpen] = useState(false);

    const [isEnabled, setIsEnabled] = useState()

    const onSubmit = (data) => {

        if(data){
            props.onDataUpdate(
                {
                    ...data,
                    enabled: isEnabled
                }
            )
            setIsOpen(false)
        }
 
    }

    useEffect(() => {

    }, [isOpen])


    return (
        <>
            <button disabled={!!props?.disabled}
                className={`flex shadow first-letter:capitalize focus:outline-none focus:ring-2 focus:ring-offset-2  transition duration-150 ease-in-out 
              rounded  p-2 text-xl ${props?.disabled ? 'bg-gray-200 text-gray-400' : 'bg-gray-100  focus:ring-gray-200 hover:text-white hover:bg-gray-700'}`}
                onClick={() => setIsOpen(true)}>
                <BiEditAlt /> <span className="mx-2 text-sm font-medium capitalize">{t('actions.edit')} </span>
            </button>

            <ModalWrapper
                open={isOpen}
                setOpen={setIsOpen}
                title={t('actions.edit')}
            >


                <SectionWrapper
                // title={t('form.message')}
                >

                    <div className="pb-8 flex justify-between font-bold ">
                        Status <ToggleSwitch isEnabled={setIsEnabled} enabled={props.data?.enabled} />
                    </div>


                    <form className="w-[480px] " onSubmit={handleSubmit(onSubmit)}>
                        <div className="capitalize font-bold">
                            {t('form.message')}
                        </div>
                        <TextArea
                            id="french"
                            label={<Language _key="fr"  />}
                            placeholder={t('actions.enter') + " " + t('form.message')}
                            register={register("french", {
                                required: t('form.error_announcement_msg'), maxLength: { value: 100, message: t('form.error_announcement_msg') }
                            })}
                            error={errors.french}
                            defaultValue={props.data?.french}
                        />

                        <TextArea
                            id="arabic"
                            label={<Language _key="ar"  />}
                            placeholder={t('actions.enter') + " " + t('form.message')}
                            register={register("arabic", {
                                required: t('form.error_announcement_msg'), maxLength: { value: 100, message: t('form.error_announcement_msg') }
                            })}
                            error={errors.arabic}
                            defaultValue={props.data?.arabic}
                        />

                        {/* <TextArea
                            id="arabic_dialect_ma"
                            label={<Language _key="drj"  />}
                            placeholder={t('actions.enter') + " " + t('form.message')}
                            register={register("arabic_dialect_ma", {
                                required: t('form.error_announcement_msg'), maxLength: 100
                            })}
                            error={errors.arabic_dialect_ma}
                            defaultValue={props.data?.arabic_dialect_ma}
                        /> */}

             
                        <TextArea
                            id="english"
                            label={<Language _key="en"  />}
                            placeholder={t('actions.enter') + " " + t('form.message')}
                            register={register("english", {
                                required: t('form.error_announcement_msg'), maxLength: { value: 100, message: t('form.error_announcement_msg') }
                            })}
                            error={errors.english}
                            defaultValue={props.data?.english}
                        />

                        <div className="justify-end flex items-center mt-8 text-sm">
                            <input type='button' value={t('actions.cancel')} onClick={() => setIsOpen(false)}
                                className='capitalize bg-gray-100 rounded  px-4 py-2  mx-2 border-1 border-gray-500  cursor-pointer hover:bg-gray-300 shadow'
                            />
                            <input
                                className={`capitalize text-white rounded px-4 py-2 border-1 shadow-md ${isValid ? 'bg-blue-500 border-blue-500 cursor-pointer hover:bg-blue-600' : 'bg-blue-300 border-blue-300 cursor-not-allowed opacity-60'}`}
                                type="submit" value={t('actions.update')} disabled={!isValid} />
                        </div>

                    </form>
                </SectionWrapper>

            </ModalWrapper>

        </>


    );

}

EditAnnouncement.propTypes = {
  onDataUpdate: PropTypes.func,
  disabled: PropTypes.bool,
  data: PropTypes.shape({
    enabled: PropTypes.bool,
    french: PropTypes.string,
    arabic: PropTypes.string,
    english: PropTypes.string,
  }),
};

export default EditAnnouncement;

